import { Link } from 'react-router-dom';
import { FaMosque } from 'react-icons/fa6';
import { LogOut, ChevronDown, Plus } from 'lucide-react';
import './navbar.scss';
import { useState, useEffect, useRef } from 'react';
import Login from '../Login/Login';

import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
    const [user, setUser] = useState(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const checkUser = () => {
            const storedUser = localStorage.getItem("user");
            if (storedUser) {
                setUser(JSON.parse(storedUser));
            } else {
                setUser(null);
            }
        };

        // Check user on mount
        checkUser();

        // Listen for storage changes (when user logs in from Login page)
        window.addEventListener('storage', checkUser);
        
        // Also listen for custom event that can be dispatched after login
        const handleUserUpdate = () => checkUser();
        window.addEventListener('userUpdated', handleUserUpdate);

        return () => {
            window.removeEventListener('storage', checkUser);
            window.removeEventListener('userUpdated', handleUserUpdate);
        };
    }, []);

    useEffect(() => {
        // console.log("User changed:", user);
    }, [user]);

    const logout = () => {
        setUser(null);
        localStorage.removeItem("user");
        setIsDropdownOpen(false);
    };

    const handleAddMosque = () => {
        if (user) {
            navigate('/add-mosque');
        } else {
            navigate('/login', { state: { from: '/add-mosque' } });
        }
    };

    return (
        <nav className="navbar">
            <div className="navbar__container">
                <Link to="/" className="navbar__brand">
                    <FaMosque className="navbar__logo" />
                    <span className="navbar__brand-name">ചോറുള്ള പള്ളി.com</span>
                </Link>

                <div className="navbar__actions">
                    <button 
                        className="navbar__add-mosque-btn"
                        onClick={handleAddMosque}
                        title="Add Mosque"
                    >
                        <Plus size={18} />
                        <span>Add Mosque</span>
                    </button>

                    <div className="navbar__auth">
                        {user ? (
                            <div className="navbar__user" ref={dropdownRef}>
                                <div
                                    className="navbar__user-info"
                                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                >
                                    <img
                                        src={user.picture}
                                        alt={user.name}
                                        className="navbar__user-avatar"
                                    />
                                    <span className="navbar__user-name">{user.name}</span>
                                    <ChevronDown size={16} className={`dropdown-icon ${isDropdownOpen ? 'open' : ''}`} />
                                </div>

                                {isDropdownOpen && (
                                    <div className="navbar__dropdown">
                                        <div className="dropdown-user-info">
                                            <img
                                                src={user.picture}
                                                alt={user.name}
                                                className="dropdown-avatar"
                                            />
                                            <div className="dropdown-user-details">
                                                <span className="dropdown-name">{user.name}</span>
                                                <span className="dropdown-email">{user.email}</span>
                                            </div>
                                        </div>
                                        <div className="dropdown-divider"></div>
                                        <button onClick={logout} className="dropdown-logout-btn">
                                            <LogOut size={18} />
                                            Logout
                                        </button>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="navbar__login1">
                                <GoogleLogin
                                    onSuccess={(credentialResponse) => {
                                        const decoded = jwtDecode(credentialResponse.credential);
                                        localStorage.setItem("user", JSON.stringify(decoded));
                                        setUser(decoded);
                                        navigate(-1);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;